import axiosInstance from "./axiosInstance";

export const getOrganizationTimezone = async () => {
  try {
    //@ts-ignore
    const response = await axiosInstance.get(`/ads/organization/${window.Clerk.organization.id}`
    );
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

export const updateOrganizationTimezone = async (
  timezone?: string,
  contactInfo?: { phone?: string; linkedin?: string; twitter?: string }
) => {
  try {
    //@ts-ignore
    const response = await axiosInstance.post(`/ads/organization/${window.Clerk.organization.id}`,
      { timezone, contactInfo }
    );
    return response.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

export const generateApiKey = async () => {
  try {
    const response = await axiosInstance.post(`/ads/organization/key`);
    return response.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

export const deleteApiKey = async (apiKeyId: string) => {
  try {
    const response = await axiosInstance.delete(
      `/ads/organization/key/${apiKeyId}`
    );
    return response.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

export const getApiKeys = async () => {
  try {
    const response = await axiosInstance.get(`/ads/organization/keys`);
    return response.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 获取用户权限
export const getPermissionApi = async () => {
  try {
    const response = await axiosInstance.post(`/ads/member/getPermission`);
    return response.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};
// 邮箱发送验证码
export const getOptCodeApi = async (params: { email: string }) => {
  try {
    const response = await axiosInstance.post(
      `/ads/organization/opt-code`,
      params
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};
// 邮箱发送验证码-校验
export const verifyOptCodeApi = async (params: {
  email: string;
  code: string;
  campaignId: string;
}) => {
  try {
    const response = await axiosInstance.post(
      `/ads/organization/verify-opt`,
      params
    );
    return response.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};
// 兑换邀请码
export const inviteCodeApi = async (params: { code: string }) => {
  try {
    const response = await axiosInstance.post(
      `/ads/wallet/invite-code/redeem`,
      params
    );
    return response.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};
// AI chart
export const chatBotApi = async (params: any) => {
  try {
    const response = await axiosInstance.post(`v1/chatbot`, params);
    return response.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};
// 创建campaign 后 查看节点执行情况
export const campaignAiInfoApi = async (campaignId: string) => {
  try {
    const response = await axiosInstance.get(
      `v1/chatbot/campaignInfo/${campaignId}`
    );
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 获取当前被动暂停的campaign详情
export const systemTempPausedApi = async () => {
  try {
    const response = await axiosInstance.get(
      `/ads/campaign/v3/systemTempPaused`
    );
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 获取当前所有的全局提醒
export const getGlobalAlertList = async () => {
  try {
    const response = await axiosInstance.get(`/ads/campaign/v3/alert`);
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 全局提醒关闭
export const closeGlobalAlertApi = async (campaignId: string, params: any) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v3/${campaignId}/clearAlert`,
      params
    );
    return response.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// release campaign 时判断work email 是否和website不匹配或者是敏感行业
export const getEmailCheckApi = async (campaignId: string) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v3/${campaignId}/releaseCheck`,
      {}
    );
    return response.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 校验敏感行业 || 邮箱不匹配的文件提交

export const checkEmailFilesApi = async (
  campaignId: string,
  params: { files: string[] }
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v3/${campaignId}/submitReviewFiles`,
      params
    );
    return response.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 获取组织详情
export const getOrganizationDetail = async (clerkOrgId: string | undefined) => {
  try {
    const response = await axiosInstance.get(`/ads/organization/${clerkOrgId}`);
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 创建组织
export const createOrganizationApi = async (params: {
  clerkOrgName: string;
  logoUrl: string;
}) => {
  try {
    const response = await axiosInstance.post(
      `/ads/organization/create`,
      params
    );
    return response.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 生成组织信息
export const createOrganizationInfoApi = async () => {
  try {
    const response = await axiosInstance.post(`/ads/organization/info`, {});
    return response.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 创建组织发送短信验证码
export const createOrganizationInfoSendCodeApi = async (
  clerkOrgId: string,
  params: { phone: string }
) => {
  try {
    //@ts-ignore
    const response = await axiosInstance.post(
      `/ads/organization/${clerkOrgId}/sms/code`,
      params
    );
    return response.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 更新组织信息 V2
export const updateOrganizationInfoApi = async (
  clerkOrgId: string,
  params: any
) => {
  try {
    //@ts-ignore
    const response = await axiosInstance.post(
      `/ads/organization/${clerkOrgId}/update`,
      params
    );
    return response.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 发送验证码
export const sendVerificationCode = async (phone: string) => {
  try {
    //@ts-ignore
    const response = await axiosInstance.post(`/ads/organization/sms/code`, {
      phone,
    });
    return response.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 验证验证码
export const verifyVerificationCode = async (params: any) => {
  try {
    //@ts-ignore
    const response = await axiosInstance.post(
      `/ads/organization/sms/verify`,
      params
    );
    return response.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 获取book demo 信息（不鉴权）
export const getBookDemoStatusApi = async (email: string) => {
  try {
    //@ts-ignore
    const response = await axiosInstance.post(`/ads/organization/book/status`, {
      email,
    });
    return response.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 设置语言

export const setLanguageApi = async (params: {language: string}) => {
  try {
    const response = await axiosInstance.post(`/ads/member/language`, params);
    return response.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};
// use case match
export const getUseCaseMatchApi = async (params: {domain?: string, count: number}) => {
  try {
    const response = await axiosInstance.post(`/ads/organization/use-cases/match`, params);
    return response.data?.data;
  } catch (error: any) {
    // 确保错误消息不为空
    const errorMessage = error?.message || error?.error || 'Failed to get use case match';
    throw new Error(errorMessage);
  }
};

// 获取功能更新提醒
export const getFeatureUpdateReminderApi = async (language: string) => {
  try {
    const response = await axiosInstance.get(`/ads/sys/uphint?language=${language}`);
    return response.data?.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};